import {shape, arrayOf, string} from 'prop-types';
import {SortDirection} from 'utils/DBUtils';

const filterPropType = shape({
  field: string,
  value: string,
  operator: string
});

export const FilterOptionsPropShape = shape({
  namedFilters: arrayOf(string),
  filters: arrayOf(filterPropType)
})

export const filterOptionsFactory = ({ namedFilters, filters } = {}) => ({
  namedFilters: namedFilters || [],
  filters: filters || []
});

export const sortOptionsFactory = (...possibleFields) => ({
  sorts: (possibleFields || []).reduce((sorts, field) => {
    sorts[field] = SortDirection.Unsorted;
    return sorts;
  }, {})
});



// WEBPACK FOOTER //
// ./public/viewOptions/factories.js